import * as Yup from 'yup';

export const OtherExpenseUpdateFormSchema = () =>
  Yup.object({
    amount: Yup.number().default(0),
    description: Yup.string().default(''),
    transactionAt: Yup.date().default(new Date()),
    accountType: Yup.string().nullable().default(null),
    accountableId: Yup.string().nullable().default(null),
  });

export const OtherExpenseDetailCreateFormSchema = () =>
  Yup.object({
    amount: Yup.number().default(0),
    description: Yup.string().default(''),
    transactionAt: Yup.date().default(new Date()),
    accountType: Yup.string().nullable().default(null),
    accountableId: Yup.string().nullable().default(null),
  });

export const OtherExpenseCreateFormSchema = () =>
  Yup.object({
    expensableRefId: Yup.string().default(''),
    expensableRefType: Yup.string().default('Tour'),
    otherExpenses: Yup.array(OtherExpenseDetailCreateFormSchema()).default([]),
  });

export type OtherExpenseUpdateFormType = Yup.InferType<
  ReturnType<typeof OtherExpenseUpdateFormSchema>
>;

export type OtherExpenseDetailCreateFormType = Yup.InferType<
  ReturnType<typeof OtherExpenseDetailCreateFormSchema>
>;

export type OtherExpenseCreateFormType = Yup.InferType<
  ReturnType<typeof OtherExpenseCreateFormSchema>
>;
